// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gcimnsbeexkkqragmdzo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdjaW1uc2JlZXhra3FyYWdtZHpvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg1MzI5MTEsImV4cCI6MjA2NDEwODkxMX0.Pwq8q3IP60BkTkl9TdMa5PWOVSayKaMXVY8Z3XJ-1UA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);